var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M48 32h18v-2H48zM48 36h18v-2H48z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M20 32h2v-2h-2zM24 32h2v-2h-2zM28 32h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.463 64H70V26H16v36a3.97 3.97 0 01-.537 2zM72 66H12c-2.206 0-4-1.794-4-4V14h19.414l4 4H68v4h-2v-2H30.586l-4-4H10v46c0 1.103.897 2 2 2s2-.897 2-2V24h58v42z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M20 60h46v-2H20z",
    className: "fi-icon-illustrative-base-fill"
  }))));
}

export default SvgIconIllustrationFolder;